const websocket = (app, filter) => `
${process.env.REACT_APP_WSS}/stream?app=${app}&filter=${filter}
`;

export default websocket;
